import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import React from "react";
import { Typography, ShadowContainer, CheckboxFilterGroup, makeStyles } from "componentLibrary";
import Search from "dashboard/BrokerHome/DealsViewPages/SearchField";
import CreateCustomColumns from "componentLibrary/CustomizeColumns/CreateCustomColumns";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var leftSectionStyles = makeStyles(function (theme) {
  return {
    existingColumnsContainer: function existingColumnsContainer(_ref) {
      var editingColumn = _ref.editingColumn,
        isPhone = _ref.isPhone;
      return {
        width: "100%",
        padding: "16px",
        height: editingColumn === false ? "50%" : "30%",
        maxHeight: isPhone ? "280px" : "none",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      };
    },
    customColumnsContainer: function customColumnsContainer(_ref2) {
      var editingColumn = _ref2.editingColumn;
      return {
        width: "100%",
        padding: "16px",
        height: editingColumn === false ? "50%" : "70%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      };
    },
    contentWrapper: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    },
    titleMargin: {
      marginBottom: "8px"
    },
    searchMargin: {
      marginBottom: "16px"
    },
    checkboxContainer: {
      flex: 1,
      overflow: "auto",
      minHeight: 0,
      height: "100%"
    },
    customColumnsWrapper: {
      flex: 1,
      overflow: "auto",
      minHeight: 0
    }
  };
});
var CustomizeTransactionColumns = function CustomizeTransactionColumns(_ref3) {
  var transactionColumns = _ref3.transactionColumns,
    selectedColumns = _ref3.selectedColumns,
    setSelectedColumns = _ref3.setSelectedColumns,
    editingColumn = _ref3.editingColumn,
    setEditingColumn = _ref3.setEditingColumn,
    organizationId = _ref3.organizationId,
    customColumns = _ref3.customColumns,
    customColumnsState = _ref3.customColumnsState,
    setCustomColumnsState = _ref3.setCustomColumnsState,
    searchBy = _ref3.searchBy,
    onChangeSearchValue = _ref3.onChangeSearchValue,
    onCheckboxFilterChange = _ref3.onCheckboxFilterChange,
    showAlert = _ref3.showAlert,
    isPhone = _ref3.isPhone;
  var classes = leftSectionStyles({
    editingColumn: editingColumn,
    isPhone: isPhone
  });
  var allFilteredColumns = transactionColumns === null || transactionColumns === void 0 ? void 0 : _filterInstanceProperty(transactionColumns).call(transactionColumns, function (column) {
    var _column$label, _context;
    return column === null || column === void 0 || (_column$label = column.label) === null || _column$label === void 0 ? void 0 : _includesInstanceProperty(_context = _column$label.toLowerCase()).call(_context, searchBy === null || searchBy === void 0 ? void 0 : searchBy.toLowerCase());
  });
  var checkboxGroupElements = _mapInstanceProperty(allFilteredColumns).call(allFilteredColumns, function (column) {
    return {
      id: column.id,
      label: column.label,
      isChecked: _someInstanceProperty(selectedColumns).call(selectedColumns, function (selected) {
        return selected.id === column.id;
      }),
      isDisabled: column.isDefault
    };
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ShadowContainer, {
      className: classes.existingColumnsContainer,
      children: /*#__PURE__*/_jsxs("div", {
        className: classes.contentWrapper,
        children: [/*#__PURE__*/_jsx("div", {
          className: classes.titleMargin,
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_small",
            weight: "semibold",
            children: "Existing Columns"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classes.searchMargin,
          children: /*#__PURE__*/_jsx(Search, {
            onChange: onChangeSearchValue,
            placeholder: "Search"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classes.checkboxContainer,
          children: /*#__PURE__*/_jsx(CheckboxFilterGroup, {
            filterName: "transactionColumns",
            checkboxGroupElements: checkboxGroupElements,
            onChange: onCheckboxFilterChange,
            disabled: editingColumn !== false
          })
        })]
      })
    }), /*#__PURE__*/_jsx(ShadowContainer, {
      className: classes.customColumnsContainer,
      children: /*#__PURE__*/_jsxs("div", {
        className: classes.contentWrapper,
        children: [/*#__PURE__*/_jsx("div", {
          className: classes.titleMargin,
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_small",
            weight: "semibold",
            children: "Custom Columns"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classes.customColumnsWrapper,
          children: /*#__PURE__*/_jsx(CreateCustomColumns, {
            customColumnDefinitions: customColumns,
            editingColumn: editingColumn,
            setEditingColumn: setEditingColumn,
            organizationId: organizationId,
            selectedColumns: selectedColumns,
            onCheckboxFilterChange: onCheckboxFilterChange,
            showAlert: showAlert,
            setSelectedColumns: setSelectedColumns,
            customColumns: customColumnsState,
            setCustomColumns: setCustomColumnsState
          })
        })]
      })
    })]
  });
};
export default CustomizeTransactionColumns;